import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Checkbox,
  Tooltip,
  Dropdown,
  Menu,
  Input,
  Modal
} from "antd"

import { MoreIcon, CheckedIcon, InvoiceIcon } from "../core/icons"
import Line from "../core/Line"
// import CreateSubscriptionSuccessModal from "./CreateSubscriptionSuccessModal"

import Card, { TitleCard, CardHeader } from "../core/Card"
import {
  getPlans,
  getInvoices,
  selectPlanFromUrl,
  handleCancelReactivateClick,
  selectPlan
} from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import Features from "./Features"
import FAQ from "./FAQ"
import ConnectedPlan from "./ConnectedPlan"
import PremiumFeatures from "./PremiumFeatures"
import NewStripeForm from "./NewStripeForm"
import { CreateSubModal, ManageStripeForm, CancelOrReactivateSub } from "./"
import styled from "styled-components"

const PlanLine = ({
  amount,
  interval,
  nickname,
  id,
  trial_period_days,
  current_plan,
  isSetToCancel,
  seats,
  onClick,
  selectPlan,
  checked,
  handleSeatChange,
  allowSeats
}) => (
  <Row
    type="flex"
    align="middle"
    // justify="center"
    style={{ padding: 10 }}
  >
    <Col sm={3} />
    <Col sm={13} style={{ textTransform: "capitalize" }}>
      <Checkbox
        className="checkbox-xlarge round"
        checked={checked}
        onClick={() =>
          onClick({ productIdentifier: id, total: amount, interval })
        }
      >
        <span style={current_plan ? { fontWeight: 600 } : {}}>
          {nickname || interval + "ly"}{" "}
        </span>
        {trial_period_days &&
          `- ${moment.duration(trial_period_days, "day").humanize()} trial `}

        {allowSeats &&
          current_plan && (
            <a onClick={handleSeatChange}>
              (Seats: {seats} <AIcon type="edit" />)
            </a>
          )}
      </Checkbox>
    </Col>
    {/* {allowSeats && (
      <Col sm={3}>
        {current_plan && (
          <a onClick={handleSeatChange}>
            Seats: {seats} <AIcon type="edit" />
          </a>
        )}
      </Col>
    )} */}
    <Col sm={5}>
      {numeral(amount / 100).format("($0,0.00)")} /
      {allowSeats && " user / "}
      {interval}
    </Col>
  </Row>
)

class PlanLines extends React.Component {
  state = {
    selectedPlan: null
  }

  setPlan = selectedPlan => {
    this.setState({
      selectedPlan
    })
  }

  changePlan = () => {
    if (!this.state.selectedPlan) {
      const currentPlan = this.props.plans.find(plan => plan.current_plan)

      //     {
      // "id": "stripe.yearly.premium",
      // "amount": 6000,
      // "interval": "year",
      // "nickname": null,
      // "trial_period_days": null,
      // "current_plan": true

      return this.props.selectPlan(
        currentPlan.id
        // currentPlan.amount,
        // currentPlan.interval
      )
    }
    // else
    this.props.selectPlan(
      this.state.selectedPlan.productIdentifier
      // this.state.selectedPlan.total,
      // this.state.selectedPlan.interval
    )
  }

  render() {
    const currentPlan = this.props.plans.find(plan => plan.current_plan)
    const { selectedPlan } = this.state
    return (
      <Card
        showLoadingIcon={this.props.isFetchingPlans}
        style={{ minHeight: 160 }}
      >
        {/* <CardHeader
          title="Plan"
          buttonTitle="Update"
          buttonDisabled={!(this.props.allowSeats || this.state.selectedPlan)}
          buttonOnClick={this.changePlan}
        /> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 20
          }}
        >
          <h1 style={{ margin: 0 }}>Plans</h1>
          <AButton
            disabled={
              !(this.props.allowSeats || selectedPlan) ||
              (selectedPlan && selectedPlan.productIdentifier == currentPlan.id)
            }
            onClick={this.changePlan}
          >
            Update
          </AButton>
        </div>

        {this.props.plans.map((plan, i) => (
          <PlanLine
            key={i}
            {...plan}
            allowSeats={this.props.allowSeats}
            seats={this.props.seats}
            onClick={this.setPlan}
            handleSeatChange={this.changePlan}
            checked={
              selectedPlan
                ? selectedPlan.productIdentifier == plan.id
                : plan.current_plan
            }
          />
        ))}
      </Card>
    )
  }
}

export default connect(
  state => {
    const { plans, invoices, user } = state.models
    return {
      plans,
      seats: user.subscription.customer.subscription.quantity,
      allowSeats: !!user.group_as_enterprise_owner
    }
  },
  dispatch => {
    return {
      ...bindActionCreators({ selectPlan }, dispatch),
      dispatch
    }
  }
)(
  onMount(({ dispatch }) => {
    dispatch(getPlans())
    dispatch(selectPlanFromUrl())
  })(PlanLines)
)



// WEBPACK FOOTER //
// ./src/subscriptions/PlanLines.js